module.exports = __webpack_public_path__ + "img/main.d2cbf86f.png";